import { useLocation } from "react-router-dom";
import { getNavigationItem } from "../app/navigation";
import ThemeToggle from "./ThemeToggle";
import UserMenu from "./UserMenu";

function Topbar() {
  const location = useLocation();
  const activeItem = getNavigationItem(location.pathname);

  return (
    <header className="topbar">
      <div className="topbar-main">
        <div className="topbar-left">
          <div>
            <h1 className="topbar-title">{activeItem.label}</h1>
          </div>
        </div>

        <div className="topbar-actions">
          <div className="cluster">
            <ThemeToggle />
            <UserMenu />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Topbar;
